"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteMediaEvents = exports.RemoteMedia = void 0;
exports.getMaxFs = getMaxFs;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _eventsScope = _interopRequireDefault(require("../common/events/events-scope"));
var _receiveSlot = require("./receiveSlot");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable valid-jsdoc */
var RemoteMediaEvents = exports.RemoteMediaEvents = {
  SourceUpdate: _receiveSlot.ReceiveSlotEvents.SourceUpdate,
  Stopped: 'stopped'
};
// highest possible resolution

var MAX_FS_VALUES = {
  '90p': 60,
  '180p': 240,
  '360p': 920,
  '720p': 3600,
  '1080p': 8192
};

/**
 * Converts pane size into h264 maxFs
 * @param {PaneSize} paneSize
 * @returns {number}
 */
function getMaxFs(paneSize) {
  var maxFs;
  switch (paneSize) {
    case 'thumbnail':
      maxFs = MAX_FS_VALUES['90p'];
      break;
    case 'very small':
      maxFs = MAX_FS_VALUES['180p'];
      break;
    case 'small':
      maxFs = MAX_FS_VALUES['360p'];
      break;
    case 'medium':
      maxFs = MAX_FS_VALUES['720p'];
      break;
    case 'large':
      maxFs = MAX_FS_VALUES['1080p'];
      break;
    case 'best':
      maxFs = MAX_FS_VALUES['1080p']; // for now 'best' is 1080p, so same as 'large'
      break;
    default:
      _loggerProxy.default.logger.warn("RemoteMedia#getMaxFs --> unsupported paneSize: ".concat(paneSize, ", using \"medium\" instead"));
      maxFs = MAX_FS_VALUES['720p'];
  }
  return maxFs;
}
var remoteMediaCounter = 0;

/**
 * Class representing a remote audio/video stream.
 *
 * Internally it is associated with a specific receive slot
 * and a media request for it.
 */
var RemoteMedia = exports.RemoteMedia = /*#__PURE__*/function (_EventsScope) {
  (0, _inherits2.default)(RemoteMedia, _EventsScope);
  var _super = _createSuper(RemoteMedia);
  /**
   * Constructs RemoteMedia instance
   *
   * @param receiveSlot
   * @param mediaRequestManager
   * @param options
   */
  function RemoteMedia(receiveSlot, mediaRequestManager, options) {
    var _this;
    (0, _classCallCheck2.default)(this, RemoteMedia);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "receiveSlot", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mediaRequestManager", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "options", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mediaRequestId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "id", void 0);
    remoteMediaCounter += 1;
    _this.receiveSlot = receiveSlot;
    _this.mediaRequestManager = mediaRequestManager;
    _this.options = options || {};
    _this.setupEventListeners();
    _this.id = "RM".concat(remoteMediaCounter, "-").concat(_this.receiveSlot.id);
    return _this;
  }

  /**
   * Supply the width and height of the video element
   * to restrict the requested resolution to this size
   * @param width width of the video element
   * @param height height of the video element
   * @note width/height of 0 will be ignored
   */
  (0, _createClass2.default)(RemoteMedia, [{
    key: "setSizeHint",
    value: function setSizeHint(width, height) {
      var _this$receiveSlot;
      // only base on height for now
      var fs;
      if (width === 0 || height === 0) {
        return;
      }

      // we switch to the next resolution level when the height is 10% more than the current resolution height
      // except for 1080p - we switch to it immediately when the height is more than 720p
      var threshold = 1.1;
      var getThresholdHeight = function getThresholdHeight(h) {
        return Math.round(h * threshold);
      };
      if (height < getThresholdHeight(90)) {
        fs = MAX_FS_VALUES['90p'];
      } else if (height < getThresholdHeight(180)) {
        fs = MAX_FS_VALUES['180p'];
      } else if (height < getThresholdHeight(360)) {
        fs = MAX_FS_VALUES['360p'];
      } else if (height <= 720) {
        fs = MAX_FS_VALUES['720p'];
      } else {
        fs = MAX_FS_VALUES['1080p'];
      }
      (_this$receiveSlot = this.receiveSlot) === null || _this$receiveSlot === void 0 ? void 0 : _this$receiveSlot.setMaxFs(fs);
    }

    /**
     * Invalidates the remote media by clearing the reference to a receive slot and
     * cancelling the media request.
     * After this call the remote media is unusable.
     *
     * @param {boolean} commit - whether to commit the cancellation of the media request
     * @internal
     */
  }, {
    key: "stop",
    value: function stop() {
      var _this$receiveSlot2;
      var commit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.cancelMediaRequest(commit);
      (_this$receiveSlot2 = this.receiveSlot) === null || _this$receiveSlot2 === void 0 ? void 0 : _this$receiveSlot2.removeAllListeners();
      this.receiveSlot = undefined;
      this.emit({
        file: 'multistream/remoteMedia',
        function: 'stop'
      }, RemoteMediaEvents.Stopped, {});
    }

    /**
     * Sends a new media request. This method can only be used for receiver-selected policy,
     * because only in that policy we have a 1-1 relationship between RemoteMedia and MediaRequest
     * and the request id is then stored in this RemoteMedia instance.
     * For active-speaker policy, the same request is shared among many RemoteMedia instances,
     * so it's managed through RemoteMediaGroup
     *
     * @internal
     */
  }, {
    key: "sendMediaRequest",
    value: function sendMediaRequest(csi, commit) {
      if (this.mediaRequestId) {
        this.cancelMediaRequest(false);
      }
      if (!this.receiveSlot) {
        throw new Error('sendMediaRequest() called on an invalidated RemoteMedia instance');
      }
      this.mediaRequestId = this.mediaRequestManager.addRequest({
        policyInfo: {
          policy: 'receiver-selected',
          csi: csi
        },
        receiveSlots: [this.receiveSlot],
        codecInfo: this.options.resolution && {
          codec: 'h264',
          maxFs: getMaxFs(this.options.resolution)
        }
      }, commit);
    }

    /**
     * @internal
     */
  }, {
    key: "cancelMediaRequest",
    value: function cancelMediaRequest(commit) {
      if (this.mediaRequestId) {
        this.mediaRequestManager.cancelRequest(this.mediaRequestId, commit);
        this.mediaRequestId = undefined;
      }
    }

    /**
     * registers event listeners on the receive slot and forwards all the events
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      if (this.receiveSlot) {
        var scope = {
          file: 'multistream/remoteMedia',
          function: 'setupEventListeners'
        };
        this.receiveSlot.on(_receiveSlot.ReceiveSlotEvents.SourceUpdate, function (data) {
          _this2.emit(scope, RemoteMediaEvents.SourceUpdate, data);
        });
      }
    }

    /**
     * Getter for mediaType
     */
  }, {
    key: "mediaType",
    get: function get() {
      var _this$receiveSlot3;
      return (_this$receiveSlot3 = this.receiveSlot) === null || _this$receiveSlot3 === void 0 ? void 0 : _this$receiveSlot3.mediaType;
    }

    /**
     * Getter for memberId
     */
  }, {
    key: "memberId",
    get: function get() {
      var _this$receiveSlot4;
      return (_this$receiveSlot4 = this.receiveSlot) === null || _this$receiveSlot4 === void 0 ? void 0 : _this$receiveSlot4.memberId;
    }

    /**
     * Getter for csi
     */
  }, {
    key: "csi",
    get: function get() {
      var _this$receiveSlot5;
      return (_this$receiveSlot5 = this.receiveSlot) === null || _this$receiveSlot5 === void 0 ? void 0 : _this$receiveSlot5.csi;
    }

    /**
     * Getter for source state
     */
  }, {
    key: "sourceState",
    get: function get() {
      var _this$receiveSlot6;
      return (_this$receiveSlot6 = this.receiveSlot) === null || _this$receiveSlot6 === void 0 ? void 0 : _this$receiveSlot6.sourceState;
    }

    /**
     * Getter for remote media stream
     */
  }, {
    key: "stream",
    get: function get() {
      var _this$receiveSlot7;
      return (_this$receiveSlot7 = this.receiveSlot) === null || _this$receiveSlot7 === void 0 ? void 0 : _this$receiveSlot7.stream;
    }

    /**
     * @internal
     * @returns {ReceiveSlot}
     */
  }, {
    key: "getUnderlyingReceiveSlot",
    value: function getUnderlyingReceiveSlot() {
      return this.receiveSlot;
    }
  }]);
  return RemoteMedia;
}(_eventsScope.default);
//# sourceMappingURL=remoteMedia.js.map
